/**
* @author Eduardo Roman
* @description Verifica que no exista un producto/zona geografica
* @updatedDate 24-09-2024
 * @param {*} event
 * @param {Array} selectedElements
 * @param {Function} setSelectedElements
 * @param {Array} arrayOriginalFiltrado
 * @param {Function} setArrayOriginalFiltrado
 */
const handleSelectedElements = (event, selectedElements, setSelectedElements, arrayOriginalFiltrado, setArrayOriginalFiltrado) => {
    const isElementSelected = selectedElements.some(branch => branch.id === event.value.id);
    if (!isElementSelected) {

        //Traeme todos menos el que acabo de seleccionar & los ya seleccionados anteriormente sobre el catalogo original
        const updatedArray = arrayOriginalFiltrado.filter(el =>
            el.id !== event.value.id &&
            !selectedElements.some(selected => selected.id === el.id)
        );

        setSelectedElements([...selectedElements, event.value]);

        setTimeout(() => {
            setArrayOriginalFiltrado(updatedArray);
        }, 1000)
    }
};
export { handleSelectedElements }